module.exports = __webpack_public_path__ + "img/ic_activity_att.931e4d9f.svg";